import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api, apiError } from "@/lib/apiClient";
import AuthShell from "@/components/layout/AuthShell";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please sign in.");
      navigate("/login");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Choose a new password" subtitle="Enter a new password for your account."
      footer={<Link to="/login" className="text-zinc-200 underline underline-offset-4">Back to sign in</Link>}>
      {!token ? (
        <div className="rounded-md border border-red-900/50 bg-red-950/30 p-4 text-sm text-red-300" data-testid="reset-no-token">
          Missing or invalid reset token.
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
          <div className="space-y-2">
            <Label htmlFor="password" className="text-zinc-300">New password</Label>
            <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              data-testid="reset-password" className="bg-zinc-950 border-zinc-800" minLength={8} required />
          </div>
          <Button type="submit" disabled={loading} data-testid="reset-submit"
            className="w-full bg-zinc-50 text-zinc-900 hover:bg-zinc-200">
            {loading ? "Updating…" : "Update password"}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
